import { render, staticRenderFns } from "./NavigationFullWidth.vue?vue&type=template&id=55b3d91f"
import script from "./NavigationFullWidth.vue?vue&type=script&lang=js"
export * from "./NavigationFullWidth.vue?vue&type=script&lang=js"
import style0 from "./NavigationFullWidth.vue?vue&type=style&index=0&id=55b3d91f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports